import React, {Component} from 'react'
import Modal from "../Modal";
import ModalInstructionForm from "../../forms/file/ModalInstructionForm";
import PropTypes from "prop-types";

class InstructionModal extends Component {
    render() {
        const {id, finishCallback} = this.props;

        return <Modal id={id}>
            {(closeModal) => (
                <ModalInstructionForm closeModal={closeModal} finishCallback={finishCallback} />
            )}
        </Modal>
    }
}

InstructionModal.propTypes = {
    id: PropTypes.string.isRequired,
    finishCallback: PropTypes.func,
};

InstructionModal.defaultProps = {
    finishCallback: () => {},
};

export default InstructionModal